import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('fr')
  }

  useLanguage(lang: string) {
    this.translate.use(lang)
  }

  get currentLanguage(): string {
    return this.translate.currentLang || 'fr'
  }
}
